/**
 * @generated SignedSource<<bc66ab1d6bd28de4e96173a0a25c4cfe>>
 * @relayHash 37e31a0e354dd7077ce265c76684ca5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c318f8e7c7d6a1b89dff062863aeaa4e17597fe88363b7d7c18166bef1f997c3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c318f8e7c7d6a1b89dff062863aeaa4e17597fe88363b7d7c18166bef1f997c3",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
